import { $, onReady } from "../libraries/utils"
import Swiper, { Autoplay, FreeMode, Navigation, Pagination } from "swiper"

onReady(function () {
    initHomeSlider()
    initHomeInspirationsSlider()
    initCategorySlider()
    initProductSlider()
    initReviewsSlider()
})

// Home slider
function initHomeSlider() {
    const $homeSliderContainer = $(".js-swiper-home-slider")
    if (!$homeSliderContainer) {
        return
    }

    let homeSliderAutoPlay = 5000

    let homeSlider = new Swiper(".swiper-home-slider", {
        modules: [Navigation, Pagination, Autoplay],
        autoplay: {
            delay: homeSliderAutoPlay,
        },
        rewind: true,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>'
            },
        },
        on: {
            init: function (info) {
                $homeSliderContainer.dispatchEvent(
                    new CustomEvent("swiper-ready", { detail: info })
                )
            },
            transitionStart: function (info) {
                $homeSliderContainer.dispatchEvent(
                    new CustomEvent("swiper-transition-start", { detail: info })
                )
            },
        },
    })
}

// Home slider
function initHomeInspirationsSlider() {
    const $homeInspirationsSliderContainer = $(
        ".js-swiper-home-inspirations-slider"
    )
    if (!$homeInspirationsSliderContainer) {
        return
    }

    let homeInspirationsSlider = new Swiper(
        ".swiper-home-inspirations-slider",
        {
            modules: [Navigation, FreeMode],
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            loopAdditionalSlides: 1,
            simulateTouch: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1440: {
                    slidesPerView: 2,
                },
            },
        }
    )
}

function initCategorySlider() {
    const $categorySliderContainer = $(".js-swiper-category-slider")
    if (!$categorySliderContainer) {
        return
    }

    let categorySlider = new Swiper(".swiper-category-slider", {
        modules: [Navigation, FreeMode],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        loopAdditionalSlides: 1,
        simulateTouch: true,
        slideClass: "product-tile",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 4,
            },
        },
    })
}

function initProductSlider() {
    const $productSliderContainer = $(".js-swiper-product-slider")
    if (!$productSliderContainer) {
        return
    }

    let productSlider = new Swiper(".swiper-product-slider", {
        modules: [Navigation, FreeMode],
        slidesPerView: 1,
        simulateTouch: true,
        rewind: true,
        autoHeight: true,
        slideClass: "product-slide",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    })
}

function initReviewsSlider() {
    const $reviewsSlider = $(".js-swiper-reviews-slider")
    if (!$reviewsSlider) {
        return
    }

    let reviewsSlider = new Swiper(".swiper-reviews-slider", {
        modules: [Navigation, FreeMode],
        slidesPerView: 1,
        simulateTouch: true,
        rewind: true,
        autoHeight: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    })
}
